import type { CustomIconProps } from '../CustomIcon';

export const VaultTransferIcon = ({
  color,
  secondaryColor,
  ternaryColor,
  solid,
  size = 24,
  ...props
}: CustomIconProps) => {
  return (
    <svg
      width={size}
      height={size}
      fill={solid ? color : 'none'}
      xmlns='http://www.w3.org/2000/svg'
      {...props}>
      <g clipPath='url(#a)' stroke={solid ? 'none' : secondaryColor} strokeWidth={1.5}>
        <path d='M12.316 14.736h4.058c.937 0 1.697-.76 1.697-1.697m0 0c0-.937-.76-1.697-1.697-1.697H9.439c-.46 0-.9.183-1.225.51L5 15.086l4.825 4.915 1.037-1.135c.3-.328.725-.515 1.17-.515h3.735c1.85 0 3.58-.913 4.625-2.44l2.886-4.218a1.4 1.4 0 0 0-2.157-1.771l-3.05 3.116Z' />
        <path strokeLinejoin='round' d='m4.5 14.002 5.98 5.98-2.99 2.99-5.98-5.98z' />
        <rect x={9.5} y={1.001} width={7} height={7} rx={2} />
        <circle cx={13} cy={4.501} r={1.5} />
      </g>
      {solid && (
        <g transform='translate(3 2)'>
          <path
            d='M5.21415 9.85149L2 13.0866L6.82496 18.0015L7.86182 16.8673C8.16222 16.5386 8.58694 16.3515 9.03216 16.3515H12.7666C14.6163 16.3515 16.3468 15.4388 17.3915 13.9124L20.2784 9.69415C20.6872 9.09679 20.5736 8.28634 20.0163 7.8244C19.4552 7.3593 18.6312 7.40211 18.1213 7.92286L15.0705 11.0387C15.0705 10.1016 14.3108 9.34189 13.3737 9.34189H6.43881C5.97901 9.34189 5.53821 9.52531 5.21415 9.85149Z'
            fill='#BDDEE1'
          />
          <path
            d='M9.31546 12.7355H13.3737C14.3108 12.7355 15.0705 11.9758 15.0705 11.0387V11.0387M15.0705 11.0387V11.0387C15.0705 10.1016 14.3108 9.34189 13.3737 9.34189H6.43881C5.97901 9.34189 5.53821 9.52531 5.21415 9.85149L2 13.0866L6.82496 18.0015L7.86182 16.8673C8.16222 16.5386 8.58694 16.3515 9.03216 16.3515H12.7666C14.6163 16.3515 16.3468 15.4388 17.3915 13.9124L20.2784 9.69415C20.6872 9.09679 20.5736 8.28634 20.0163 7.8244V7.8244C19.4552 7.3593 18.6312 7.40211 18.1213 7.92286L15.0705 11.0387Z'
            stroke='#006D86'
            strokeWidth='1.5'
          />
          <circle cx='10' cy='2.50146' r='1.5' stroke='#006D86' strokeWidth='1.5' />
        </g>
      )}
      <defs>
        <clipPath id='a'>
          <path
            fill={solid ? secondaryColor : 'none'}
            transform='translate(.5 .001)'
            d='M0 0h24v24H0z'
          />
        </clipPath>
      </defs>
    </svg>
  );
};
